import { purpleLightGrey } from '@osano/b2b/common/colors';

export default theme => ({
    // Field label — semibold per the design spec.
    label: {
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    // Pill visual only — layout (row, gaps, alignment) is handled by <Stack>.
    pill: {
        minWidth: 0,
        height: 32,
        padding: theme.spacing(0, 1.5),
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.border}`,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        fontWeight: 400,
        textTransform: 'none',
        lineHeight: 1,
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
        },
        '&.Mui-disabled': {
            opacity: 0.5,
        },
    },
    selected: {
        backgroundColor: purpleLightGrey,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: purpleLightGrey,
            borderColor: theme.palette.primary.main,
        },
    },
});
